import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';

import DateTimeFormat from '../../../../components/dateTimeFormat';
import { TableTooltip } from '../../../../components/general/table';

import {
    InitialCausalityFilter,
    InitialCausality,
} from '../../../../../shared/types/typifications/initialCausality';
import { asyncGetInitialCausalitys } from '../../../../../services/initial.causality.service';

import { InitialCausalityListActions } from './actions';
import { RootState } from '../../../../../redux/store';
import { useSelector } from 'react-redux';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';

export const useInitialCausalityList = (filters?: InitialCausalityFilter) => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<InitialCausality[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [finalFilters, setFinalFilters] = useState<InitialCausalityFilter>(
        {}
    );

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<InitialCausality>[] = [];

    if (!isOnlyViewProfile(type)) {
        columns.push({
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <InitialCausalityListActions id={row.id} />,
        });
    }

    columns.push(
        {
            field: 'name',
            headerName: 'Nombre',
            minWidth: 120,
            flex: 0.6,
            renderCell: (row) => <TableTooltip value={`${row.row.name}`} />,
        },
        {
            field: 'active',
            headerName: 'Activo',
            minWidth: 120,
            flex: 0.2,
            valueGetter: (params) => (params.row?.active ? 'Sí' : 'No'),
        },
        {
            field: 'dateCreate',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => <DateTimeFormat dateAt={row.row.created_at} />,
        }
    );

    useEffect(() => {
        setPage(0);
        setFinalFilters(filters || {});
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        asyncGetInitialCausalitys(finalFilters, page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, finalFilters]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
